import type { MessageFunction } from 'vue-i18n';
import homepage from './pages/homepage/index';
import tech from './pages/tech/index';
import statistics from './pages/statistics/index';
import Info from './pages/info/index';
import system from './pages/system/index';
// 芬兰
export default {
    license: {
        powered_by: 'SAIC Motor International {\'|\'} Kaikki oikeudet pidätetään',
    },
    auth: {
        login: 'Kirjaudu sisään',
        username: 'Käyttäjätunnus',
        username_placeholder: 'Anna käyttäjätunnus',
        password: 'Salasana',
        password_placeholder: 'Anna salasana',
        code: 'Vahvistuskoodi',
        code_placeholder: 'Anna vahvistuskoodi',
        logout: 'Kirjaudu ulos',
        logout_success: 'Uloskirjautuminen onnistui',
        day: 'päivä',
        password_expiration: 'Salasana on vanhentunut – päivitä se',
        expire: 'Päiviä jäljellä ennen salasanan vanhenemista',
        conseils:
            'Täytyy sisältää isoja kirjaimia, pieniä kirjaimia, numeroita ja erikoismerkkejä ({msg}). Salasanan pituuden tulee olla 8–16 merkkiä.',
        brand_Selection: 'Merkkivalinta',
        unread_notices: 'Lukemattomat ilmoitukset',
        new_cases: 'Uudet tapaukset',
        unanswered_cases: 'Vastaamattomat tapaukset',
        overdue_cases: 'Myöhässä olevat tapaukset',
    },
    button: {
        query: 'Haku',
        editing_position: 'Muokkaa tehtävää',
        show_theme_editor: 'Näytä/piilota teeman muokkain',
        change_password: 'Vaihda salasana',
        old_password: 'Vanha salasana',
        new_password: 'Uusi salasana',
        confirm_password: 'Vahvista salasana',
        button: 'Painike',
        about: 'Tietoja',
        back: 'Takaisin',
        go: 'OK',
        home: 'Etusivu',
        confirm: 'Vahvista',
        modify: 'Muokkaa',
        edit: 'Muokkaa',
        new: 'Uusi',
        cancel: 'Peruuta',
        close: 'Sulje',
        search: 'Hae',
        reset: 'Nollaa',
        delete: 'Poista',
        add: 'Lisää',
        collapse: 'Tiivistä',
        expand: 'Laajenna',
        download_template: 'Lataa malli',
        batch_import: 'Tuonti erässä',
        import: 'Tuo',
        export: 'Vie',
        export_fail: 'Tuonti epäonnistui',
        detailed: 'Yksityiskohdat',
        details: 'Tiedot',
        download: 'Lataa',
        toView: 'Näytä',
        toViews: 'Näytä kuvat',
        uploadAttachments: 'Lataa liitteet',
        selectFile: 'Valitse tiedosto',
        fillingInstructions: 'Täyttöohjeet',
        release: 'Julkaise',
        release_recall: 'Peru julkaisu',
        save: 'Tallenna',
        send: 'Lähetä',
        tips: 'Vinkit',
        send_back: 'Palauta',
        examine: 'Tarkista',
        void: 'Mitätöi',
        more: 'Lisää',
        refresh: 'Päivitä',
        selects: 'Valitse',
        serial_number: 'Sarjanumero',
        upload_progress: 'Latauksen edistyminen',
        invalid: 'Virheellinen',
        daily_record: 'Päiväkirja',
        operation_type: 'Toimintatyyppi',
        field_name: 'Kentän nimi',
        edit_role: 'Muokkaa roolia',
        user_role: 'Valitse rooli',
        assignment_role: 'Rooli',
        post: 'Tehtävä',
        sending: 'Lähetetään...',
        reset_password: 'Nollaa salasana',
        display_or_not: 'Näytä vai ei',
        document: 'Asiakirja',
        specificTemplates: 'Tietynlaiset mallit',
        transferOrder: 'Siirrä tilaus',
        forwarding: 'Edelleenlähetys',
        one_click_notification: 'Ilmoitus yhdellä napautuksella',
        english_export: 'Vie englanniksi',
        oneclick_download: 'Lataa yhdellä napautuksella',
        passwordmsga:
            'Täytyy sisältää isoja kirjaimia, pieniä kirjaimia, numeroita ja erikoismerkkejä (@\\$!_~\\&*)',
        passwordmsgb: 'Salasanan pituuden tulee olla 8–16 merkkiä',
        passwordmsgc: 'Ei saa olla sama kuin kuusi viimeisintä salasanaa',
        export_file_list: 'Vientitiedostojen luettelo',
        personal_center: 'Henkilökohtainen keskus',
        upload_list: 'Latauslista',
        clear_completed: 'Tyhjennä valmiit',
    },
    radio: {
        enabled: 'Käytössä',
        disabled: 'Ei käytössä',
        catalogue: 'Luettelo',
        individual: 'Yksittäinen',
        all: 'Kaikki',
        yes: 'Kyllä',
        no: 'Ei',
    },
    dropdown: {
        close_others: 'Sulje muut',
        close_right: 'Sulje oikealla',
        close_left: 'Sulje vasemmalla',
    },
    table: {
        action: 'Toiminto',
        explain: 'Selitys',
        fileName: 'Tiedostonimi',
        size: 'Koko (Mt)',
        uploader: 'Lataaja',
        uploadTime: 'Latausaika',
        system: 'Järjestelmä',
        caption: 'Otsikko',
        categorization: 'Luokittelu',
        link: 'Linkki',
        forwarding_time: 'Edelleenlähetysaika',
        forwarder: 'Lähettäjä',
        send_to: 'Lähetä',
        mode: 'Tila',
    },
    pagination: {
        pages: ({ named }: Parameters<MessageFunction>[0]) => `${named('number')} / Sivu`,
        total: ({ named }: Parameters<MessageFunction>[0]) => `Yhteensä ${named('number')} riviä`,
        vinCount: ({ named }: Parameters<MessageFunction>[0]) =>
            `Yhteensä ${named('number')} autoa`,
    },
    confirm: {
        confirm_deletion: 'Vahvista poisto?',
        confirm_void: 'Vahvista mitätöinti?',
        confirm_release: 'Vahvista julkaisu?',
        ack: 'Vahvista',
        cancel: 'Peruuta',
        non_records: 'Valitse vähintään yksi rivi',
    },
    request: {
        failed_placeholder: 'Pyyntö epäonnistui – palvelinvirhe',
        success_placeholder: 'Pyyntö onnistui',
        auth: {
            login_success: 'Kirjautuminen onnistui',
        },
        error: {
            '404': 'Reittiä ei löydy',
            '403': 'Ei riittäviä oikeuksia',
        },
    },
    page: {
        global: {
            page_search: 'Sivuhaku',
        },
        error: {
            not_found: 'Sivua ei löytynyt',
            not_found_des: 'Täällä ei ole mitään',
            auth_failed: 'Ei riittäviä oikeuksia',
            auth_failed_des: 'Tälle sivulle pääsy on estetty',
            file_format_error: 'Virheellinen tiedostomuoto!',
            preview_failed: 'Esikatselu epäonnistui! Tiedosto on vioittunut!',
        },
        homepage: {
            homepage: homepage.homepage.fiFI,
        },
        system: {
            menu: system.menu.fiFI,
            dict: system.dict.fiFI,
            dept: system.dept.fiFI,
            role: system.role.fiFI,
            user: system.user.fiFI,
        },
        info: {
            announcement: Info.announcement.announcement.fiFI,
            document: Info.document.document.fiFI,
        },
        tech: {
            quality: {
                problemTracking: tech.quality.problemTracking.fiFI,
                recallActivity: tech.quality.recallActivity.fiFI,
                abnormalClaimTracking: tech.quality.abnormalClaimTracking.fiFI,
            },
            management: {
                inquiryOd: tech.management.inquiry.fiFI,
                permission: tech.management.permission.fiFI,
                onSiteSupportHq: tech.management.onSiteSupport.fiFI,
                progHistoryHq: tech.management.progHistory.fiFI,
                salesRecordHq: tech.management.salesRecord.fiFI,
                vehicleInfoHq: tech.management.vehicleInfo.fiFI,
                claimHq: tech.management.claim.fiFI,
                filterHq: tech.management.filter.fiFI,
                newCarlssue: tech.management.newCarIssue.fiFI,
                newCarDefinition: tech.management.newCarDefinition.fiFI,
                vehicleProductionInfo: tech.management.vehicleProductionInfo.fiFI,
                programmingHistoryInformationQuery:
                    tech.management.programmingHistoryInformationQuery.fiFI,
                ecuControllerInformationQuery: tech.management.ecuControllerInformationQuery.fiFI,
            },
        },
        components: {
            businessComponents: tech.management.businessComponents.fiFI,
        },
        statistics: statistics.inquiryStatistics.fiFI,
        systemClassifyA: statistics.systemClassifyA.fiFI,
        systemClassifyB: statistics.systemClassifyB.fiFI,
        engineerStatistics: statistics.engineerStatistics.fiFI,
        defectivePart: statistics.defectivePart.fiFI,
        replyInquiryStatistics: statistics.replyInquiryStatistics.fiFI,
        passRateStatistics: statistics.passRateStatistics.fiFI,
        timelyResponseRateStatistics: statistics.timelyResponseRateStatistics.fiFI,
        responseRateStatistics24Hour: statistics.responseRateStatistics24Hour.fiFI,
        customsClearance135Rate: statistics.customsClearance135Rate.fiFI,
        accumulatedClosureRate: statistics.accumulatedClosureRate.fiFI,
        engineerAffiliatedOrganization: statistics.engineerAffiliatedOrganization.fiFI,
        EngineerResponseRateReport: statistics.EngineerResponseRateReport.fiFI,
    },
    validation: {
        common: {
            required: 'Tämä kenttä on pakollinen',
            numeric: 'Täytyy olla kokonaisluku',
            decimal: 'Täytyy olla luku',
            positive_interger: 'Täytyy olla positiivinen kokonaisluku',
            up_to_digits: ({ named }: Parameters<MessageFunction>[0]) =>
                `Enintään ${named('number')} numeroa`,
            more_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Ei saa ylittää ${named('number')} merkkiä`,
            max_bytes: ({ named }: Parameters<MessageFunction>[0]) =>
                `Ylittää enimmäismäärän (${named('number')} merkkiä)`,
            less_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Vähintään ${named('number')} merkkiä`,
            must_be_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Täytyy olla täsmälleen ${named('number')} merkkiä`,
            greater_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Ei saa olla suurempi kuin ${named('number')}`,
            less_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Ei saa olla pienempi kuin ${named('number')}`,
            up_to_2_decimal_places: 'Enintään 2 desimaalia',
            retain_up: 'Enintään 10 numeroa ennen pilkkua, enintään 2 desimaalia',
            retain_ups: 'Enintään 11 numeroa ennen pilkkua, enintään 4 desimaalia',
            input_number: 'Anna arabialaisia numeroita',
            only_number_a: 'Vain kirjaimet tai numerot sallittuja',
            translate: 'Vain kirjaimet sallittuja',
            positive_integer: 'Täytä vähintään yksi kenttä',
            at_least_one: 'Täytä vähintään yksi',
        },
        tip: {
            incomplete_information: 'Tiedot eivät ole täydellisiä',
        },
    },
    import: {
        template_file: 'Mallitiedosto',
        browse: 'Selaa',
        download_template: 'Lataa malli',
        no_file_selected: 'Tiedostoa ei valittu',
        incorrect_file_type: 'Virheellinen tiedostotyyppi',
        exceed: 'Ylittää',
        upload_success: 'Lataus onnistui',
        upload_fail: 'Lataus epäonnistui',
        again_upload:
            'Vain jpg-, png-, bmp- tai gif-muotoiset kuvat ovat sallittuja. Yritä uudelleen.',
        attachmentUpload: 'Lataa liitteet',
        otherAttachmentUpload: 'Lataa muut liitteet',
        supportedFormats: 'Tuetut muodot',
        preview: 'Esikatselu',
    },
    export: {
        noDataToExport: 'Ei vientiä varten tietoja',
    },
    select: {
        all: 'Kaikki',
    },
    checkbox: {
        select_all: 'Valitse kaikki',
    },
    dialog: {
        error_message: 'Virheilmoitus',
        one_year: 'Kerralla voidaan viedä enintään yhden vuoden ajanjakson tiedot',
    },
    ymd: {
        year: 'vuosi',
        month: 'kuukausi',
        day: 'päivä',
        week: 'viikko',
        january: 'tammikuu',
        february: 'helmikuu',
        march: 'maaliskuu',
        april: 'huhtikuu',
        may: 'toukokuu',
        june: 'kesäkuu',
        july: 'heinäkuu',
        august: 'elokuu',
        september: 'syyskuu',
        october: 'lokakuu',
        november: 'marraskuu',
        december: 'joulukuu',
    },
};
